import { Logo } from '@/common'
import { EntityConfig } from './MesReportEmbed'
import chalcoLogo from './chalco_logo.svg'
import useI18n from '@/shared/hooks/useI18n'

export default function MesReportCoverPageZh({
  operatorName,
  cnCodes,
  startDate,
  endDate,
  productionRouteName,
  finalizedDate,
  entityConfig
}: {
  startDate: string
  endDate: string
  creationDate: string
  operatorName: string
  finalizedDate: string
  cnCodes: {
    methodCode: string
    cnCode: string
  }[]
  productionRouteName: string
  entityConfig: EntityConfig
}) {
  const { t } = useI18n()
  return (
    <div className="break-after-page min-h-[100vh] flex flex-col shadow-lg print:shadow-none justify-center items-center text-center bg-white">
      <header className="flex flex-col items-center justify-center">
        <img src={chalcoLogo} alt="Chalco Logo" className="w-32 mb-4" />
        <h1 className="font-bold text-lg">{operatorName}</h1>
      </header>
      <main className="text-text-secondary flex flex-col items-center justify-center">
        <p className="mt-2">
          报告期
          <br />从 {startDate} 到 {endDate}
        </p>
        <p className="italic text-xs mt-2">报告创建日期 {finalizedDate}</p>
        <p className="text-xs mt-2 mx-44 text-center">
          根据2023年5月10日第(EU) 2023/956号法规和2023年8月17日第(EU)
          2023/1773号实施条例的立法要求编制。
        </p>
        <div className="mt-10">
          <table className="w-full border-b">
            <thead>
              <tr className="text-left">
                <th className="py-2 px-2 font-normal">CN编码</th>
                <th className="py-2 px-2 font-normal">生产路线</th>
                <th className="py-2 px-2 font-normal">生产方法</th>
              </tr>
            </thead>
            <tbody className="bg-background-main">
              {cnCodes.map(item => (
                <tr key={item.methodCode} className="border-t">
                  <td className="py-2 px-2 font-semibold">{item.cnCode}</td>
                  <td className="py-2 px-2 font-semibold">{productionRouteName}</td>
                  <td className="py-2 px-2 font-semibold">
                    {t(`common:productionMethods.${item.methodCode}`)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex flex-col items-center justify-center mt-32">
          <Logo className="w-32 h-12" />
          <p className="text-xs">
            {entityConfig.entityName} - {entityConfig.street}
            <br />
            {entityConfig.city}, {entityConfig.country}
          </p>
        </div>
      </main>
    </div>
  )
}
